module.exports = __webpack_public_path__ + "static/img/kelp2.58f70af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/plants/kelp2.jpg
// module id = m6bU
// module chunks = 1